// extracted by mini-css-extract-plugin
export default {"counter":"ToR9ltWV9RMPjXHX"};